// @ts-ignore
export const setSession = (state, session) => {
  state.session = session;
  state.accessToken = session.data.accessToken;
};
// @ts-ignore
export const setAnonymous = (state, anonymous) => {
  state.anonymous = anonymous;
};
